import PropTypes from 'prop-types';

const TextField = ({
  input,
  label,
  labelRequired,
  type,
  placeholder,
  meta: { touched, error, warning, submitError },
  helpText,
  cssClass,
  disabled,
}) => {
  const { name, ...inputProps } = input;

  if (!error) {
    error = submitError;
  }

  return (
    <div className={`form-group text${cssClass ? ' ' + cssClass : ''}${touched && error ? ' error' : ''}`}>
      {label && (
        <label htmlFor={name}>
          {label}
          {labelRequired && <abbr title="Required">*</abbr>}
        </label>
      )}
      {disabled ? (
        <>
          <div className="form-control form-control-disabled" id={name} disabled aria-disabled="true">
            {inputProps.value}
          </div>
          <input {...inputProps} type="hidden" name={name} />
        </>
      ) : (
        <input
          {...inputProps}
          type={type}
          id={name}
          name={name}
          placeholder={placeholder}
          className="form-control"
          autoComplete="off"
          data-lpignore="true"
          data-1p-ignore="true"
          data-bwignore="true"
        />
      )}

      {helpText && <div className="text-info">{helpText}</div>}
      {touched && error && <div className="text-danger">{error}</div>}
      {touched && warning && !error && <div className="text-warning">{warning}</div>}
    </div>
  );
};

TextField.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string,
  type: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  meta: PropTypes.object,
  helpText: PropTypes.string,
  cssClass: PropTypes.string,
  disabled: PropTypes.bool,
};

export default TextField;
